export default __webpack_public_path__ + "8d52ea31666fcdf8a2fb2bf0f275aa71.svg";